import { useLocation, useNavigate } from 'react-router';
import { useLiveQuery } from 'dexie-react-hooks';
import { Banner } from '@/components/Banner';
import { Button } from '@/components/Button';
import { leerSettings, hayDatosCapturados } from '@/db/schema';
import { evaluarRespaldo } from '@/domain/backup-reminder';

/**
 * Recordatorio de respaldo pendiente (Req. 4.2, 4.3, 4.4, 4.5).
 *
 * Vive en el armazon para verse desde cualquier pantalla, no solo en el
 * dashboard. Es un aviso dentro de la aplicacion: no se usan notificaciones del
 * sistema operativo.
 */
export function BackupBanner() {
  const navegar = useNavigate();
  const ubicacion = useLocation();

  // Solo lecturas: `useLiveQuery` corre en una transaccion de solo lectura.
  const estado = useLiveQuery(async () => {
    const settings = await leerSettings();
    const hayDatos = await hayDatosCapturados();
    return evaluarRespaldo({
      ultimoRespaldoEn: settings.ultimoRespaldoEn,
      hayDatos,
      diasAviso: settings.diasAvisoRespaldo,
    });
  }, []);

  if (estado === undefined || !estado.debeAvisar) return null;

  // En la propia pantalla de respaldos el aviso seria redundante.
  if (ubicacion.pathname === '/respaldos') return null;

  return (
    <Banner
      tono={estado.nivel === 'alerta' ? 'alerta' : 'aviso'}
      titulo={estado.mensaje}
      accion={
        <Button variante="primario" completo={false} onClick={() => navegar('/respaldos')}>
          Hacer respaldo
        </Button>
      }
    >
      {estado.detalle}
    </Banner>
  );
}
